import script from "./listSection.vue?vue&type=script&setup=true&lang=js"
export * from "./listSection.vue?vue&type=script&setup=true&lang=js"

import "./listSection.vue?vue&type=style&index=0&id=81fb9f68&scoped=true&lang=scss"

import exportComponent from "E:\\project\\lms-frontend-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-81fb9f68"]])

export default __exports__